export default {"src":"/_next/static/media/PDF.bf7c7613.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};